import { render, staticRenderFns } from "./EditVideoTabAction.vue?vue&type=template&id=6734bde1&scoped=true&"
import script from "./EditVideoTabAction.vue?vue&type=script&lang=js&"
export * from "./EditVideoTabAction.vue?vue&type=script&lang=js&"
import style0 from "./EditVideoTabAction.vue?vue&type=style&index=0&id=6734bde1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6734bde1",
  null
  
)

export default component.exports